import { http } from '@/utils/api'
import { withPbx } from '@/stores/network/api'
import * as Sentry from '@/core/sentry'
import { isWhitelistError } from '@/utils/api/whitelist'

export type Tutorial = {
  name:
    | 'welcome_beta_1'
    | 'welcome_tutorial_1'
    | 'welcome_tutorial_2'
    | 'uca_welcome_1'
  state: 'finished'
  step: number
}

export async function loadTutorials() {
  try {
    const url = withPbx('tutorial-progress')

    const { data } = await http.get<Record<string, Tutorial>>(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function createTutorial(tutorial: string) {
  try {
    const url = withPbx('tutorial-progress')

    const { data } = await http.post<{ id: number }>(url, {
      name: tutorial,
      state: 'finished',
      step: 1,
    })

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function deleteTutorial(tutorialId: number | string) {
  try {
    const url = withPbx(`tutorial-progress/${tutorialId}`)

    const { data } = await http.delete(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
